import React from 'react';
import Modal from 'react-modal';
import './style.scss';

Modal.setAppElement('#root');
export type ModalBaseProps = {
  isOpen: boolean;
  modalStyle: ModalStyle;
  onRequestClose?: (e: React.KeyboardEvent) => void;
  onAfterOpen?: () => void;
  children?: React.ReactNode;
  shouldCloseOnOverlayClick?: boolean;
  spacing? : ModalSpacing;
};

export enum ModalStyle {
  /**
   * モーダルをPageのように使う用
   */
  Page,
  /**
   * メッセージ表示用
   */
  Message,
  /**
   * 規約内容変更モーダル専用
   */
  InputConsentOnly
}

export enum ModalSpacing {
  small = 'small',
  medium = 'medium',
}

const getContentStyle = (type: ModalStyle) => {
  switch (type) {
    case ModalStyle.Page:
      return 'pageContent';
    case ModalStyle.Message:
      return 'messageContent';
      case ModalStyle.InputConsentOnly:
      return 'inputConsentOnlyContent';
  }
};


export const ModalBase = (props: ModalBaseProps) => {
  const { isOpen, modalStyle, onRequestClose, onAfterOpen, children, shouldCloseOnOverlayClick, spacing } = props;

  return (
    <Modal
      isOpen={isOpen}
      overlayClassName="modalOverLay"
      className={`${getContentStyle(modalStyle)} ${spacing && `modalSpacing_${spacing}`}`}
      onRequestClose={(e: React.KeyboardEvent) => onRequestClose && onRequestClose(e)}
      onAfterOpen={onAfterOpen}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      // shouldCloseOnEsc={false}
    >
      {children}
    </Modal>
  );
};
